function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a {\n                fill: none;\n            }\n        "));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 29,
  height: 29
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1300.792 -593.979)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1321.412,600.432a.984.984,0,0,0-1.071.162l-.944.836-1.337-1.2a.994.994,0,0,0-1.329,0l-1.337,1.2-1.336-1.2a.994.994,0,0,0-1.33,0l-1.339,1.2-.945-.835a.991.991,0,0,0-1.651.747v14.443a.993.993,0,0,0,.989,1h0a1,1,0,0,0,.661-.25l.945-.838,1.338,1.192a1,1,0,0,0,1.329,0l1.336-1.2,1.337,1.2a.993.993,0,0,0,1.33,0l1.339-1.2.945.836a1.016,1.016,0,0,0,.717.25.993.993,0,0,0,.935-1V601.344A.983.983,0,0,0,1321.412,600.432Zm-.63,1.383V615.3l-.725-.645a1,1,0,0,0-1.325,0l-1.336,1.2-1.332-1.192a.994.994,0,0,0-1.33,0l-1.336,1.2-1.338-1.2a.989.989,0,0,0-1.322,0l-.734.648V601.818l.731.647a.992.992,0,0,0,1.325,0l1.333-1.2,1.336,1.194a1,1,0,0,0,1.33,0l1.336-1.195,1.337,1.2a.991.991,0,0,0,1.322,0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1312.06,609.291a.606.606,0,0,0,0,1.212h7.43a.606.606,0,0,0,0-1.212Z",
  transform: "translate(-0.382 -1.335)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1312.06,607.758h3.9a.606.606,0,0,0,0-1.212h-3.9a.606.606,0,0,0,0,1.212Z",
  transform: "translate(-0.382 -0.942)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1319.49,612.035h-7.43a.606.606,0,0,0,0,1.212h7.43a.606.606,0,0,0,0-1.212Z",
  transform: "translate(-0.382 -1.728)"
}));

var SvgComprovante = function SvgComprovante(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComprovante, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comprovante.d16fe315.svg";
export { ForwardRef as ReactComponent };